var React = require('react');

function BellInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.6114 2.41397C17.781 3.47769 20.0645 6.47217 20.0645 10V18H21.0645V20H20.0645H4.06445H3.06445V18H4.06445V10C4.06445 6.47217 6.34795 3.47769 9.51751 2.41397C10.0473 1.56492 10.9899 1 12.0645 1C13.139 1 14.0816 1.56493 14.6114 2.41397ZM6.06445 18H18.0645V10C18.0645 6.68629 15.3782 4 12.0645 4C8.75074 4 6.06445 6.68629 6.06445 10V18ZM9.23516 21C9.647 22.1652 10.7582 23 12.0645 23C13.3707 23 14.4819 22.1652 14.8937 21H9.23516Z","fill":"#C7D5D9"}));
}

BellInline.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none","role":"img","aria-label":""};

module.exports = BellInline;

BellInline.default = BellInline;
